import backGround from "../assets/images/backGround.jpg";
import homePage1 from "../assets/images/homePage/1.jpg";
import homePage2 from "../assets/images/homePage/2.jpg";
import homePage4 from "../assets/images/homePage/4.jpg";
import homePage6 from "../assets/images/homePage/6.jpg";
import homePage7 from "../assets/images/homePage/7.jpg";

export const HERO_SLIDES = [
  {
    backgroundImage: backGround,
    overlayTone: "default",
    titleKey: "Sports Flooring",
    subtitleKey:
      "Explore our premium sports flooring options at Caf Sports, designed for superior performance and safety. Contact us today for customized solutions and expert guidance",
    subtitleSize: "sm",
  },
  {
    backgroundImage: homePage1,
    overlayTone: "default",
    titleKey: "Customized Style",
    subtitleKey:
      "Indulge in the Luxury of Tailored Style, Crafted Exclusively for You",
  },
  {
    backgroundImage: homePage2,
    overlayTone: "bottom",
    titleKey: "Unmatched Durability",
    subtitleKey:
      "Experience Unparalleled Endurance Unmatched Durability That Stands the Test of Time",
  },
  {
    backgroundImage: homePage4,
    overlayTone: "default",
    titleKey: "Elevate Performance",
    subtitleKey:
      "Rise Above the Rest Elevate Your Performance to Extraordinary Levels",
  },
  {
    backgroundImage: homePage6,
    overlayTone: "default",
    titleKey: "Versatile Solutions",
    subtitleKey: "Discover Versatile Solutions Tailored to Meet Your Every Need",
  },
  {
    backgroundImage: homePage7,
    overlayTone: "default",
    titleKey: "Improve the performance",
    subtitleKey:
      "Unleash Your Potential with Premier Sports Flooring. Elevate Performance, Enhance Safety. Explore Now",
  },
];
